import React, { useEffect,useState } from "react";
import { Sparkle} from "lucide-react";

// import Structural_Materials from "../assets/tracks/Structural_Materials.jpg";
// import Smart_and_Meta_Materials from "../assets/tracks/Smart_&_Meta_Materials.jpg";
// import Polymer_Science from "../assets/tracks/Polymer_Science.jpg";
// import Optics_and_Photonics from "../assets/tracks/Optics_&_Photonics.jpg";
// import Neuroscience from "../assets/tracks/Neuroscience.jpg";
// import Meta_Materials from "../assets/tracks/Meta_Materials.jpg";
// import Materials_Science from "../assets/tracks/Materials_Science.jpg";
// import Materials_in_Aerospace from "../assets/tracks/Materials_in_Aerospace.jpg";
// import Machine_Learning from "../assets/tracks/Machine_Learning.jpg";
// import Heterostructures from "../assets/tracks/Heterostructures.jpg";
// import Graphene_Technologies from "../assets/tracks/Graphene_Technologies.jpg";
// import Energy_Science from "../assets/tracks/Energy_Science.jpg";
// import Electronic_Devices from "../assets/tracks/Electronic Devices.jpg";
// import Cognitive_Robotics from "../assets/tracks/Cognitive_Robotics.jpg";
// import Cloud_Computing from "../assets/tracks/Cloud_Computing.jpg";
// import Biomedical_Engineering from "../assets/tracks/Biomedical Engineering.jpg";
// import Biomaterials from "../assets/tracks/Biomaterials.jpg";
// import AI_in_Nanotechnology from "../assets/tracks/AI_in_Nanotechnology.jpg";
// import AI_in_Cybersecurity from "../assets/tracks/AI_in_Cybersecurity.jpg";
// import ThreeD_Printing_Technology from "../assets/tracks/3D_Printing_Technology.jpg";

// export const tracks = [
//   {
//     image: AI_in_Nanotechnology,
//     title: "AI in Nanotechnology",
//     subtitle: "Revolutionizing Nano with AI",
//     description:
//       "Explore how Artificial Intelligence in Nanotechnology drives Precision Medicine, Smart Materials, and Nanoelectronics. Empowering Deep Learning Models, Real-Time Diagnostics, and Predictive Analytics, AI Accelerates Innovation in Research, Drug Delivery, and Material Design with Unmatched Accuracy, Efficiency, and Speed for Disruptive Technological Breakthroughs and Competitive Industry Advancement.",
//   },
//   {
//     image: Materials_Science,
//     title: "Materials Science",
//     subtitle: "Innovations in Materials Science",
//     description:
//       "Discover Cutting-Edge Materials Science Advancements Transforming Aerospace, Electronics, and Energy. Explore Nanomaterials, Composites, and Smart Materials Revolutionizing Manufacturing Efficiency, Performance, and Sustainability. Dive into Property Engineering, Molecular Innovation, and Cross-Disciplinary Applications Driving Next-Generation Solutions, Industrial Growth, and Scientific Discovery for Global Competitiveness and Advanced Engineering Outcomes.",
//   },
//   {
//     image: Structural_Materials,
//     title: "Structural Materials",
//     subtitle: "Stronger, Smarter Structures",
//     description:
//       "Explore Structural Materials Engineered for Strength, Durability, and Innovation. Discover High-Performance Composites, Alloys, and Ceramics Used in Infrastructure, Aerospace, and Automotive Industries. Enhance Design Efficiency, Thermal Stability, and Load-Bearing Capabilities Through Smart Fabrication, Advanced Processing, and Sustainable Engineering for Long-Term Industrial Performance and Structural Excellence.",
//   },
//   {
//     image: Meta_Materials,
//     title: "Meta Materials",
//     subtitle: "Beyond Nature: Metamaterials",
//     description:
//       "Unlock Metamaterials Designed to Control Electromagnetic Waves for Invisibility, Superlenses, and Stealth Applications. Explore Advanced Fabrication, Negative Refraction, and Nanoengineering Concepts Shaping Optical Innovation, Defense Technologies, and Next-Gen Communication Systems With Breakthroughs in Wave Manipulation, Frequency Control, and Unconventional Light Behavior for Scientific Progress.",
//   },
//   {
//     image: Biomaterials,
//     title: "Biomaterials",
//     subtitle: "Biomaterials in Health & Tech",
//     description:
//       "Explore Biomaterials Driving Innovation in Regenerative Medicine, Tissue Engineering, and Implants. Discover Biocompatible Polymers, Smart Surfaces, and Drug Delivery Systems Enhancing Patient Outcomes, Personalized Therapies, and Medical Device Efficiency. Accelerate Clinical Success, Biomedical Integration, and Future-Ready Healthcare Advancements Through Safe, Sustainable, and Targeted Material Technologies.",
//   },
//   {
//     image: Electronic_Devices,
//     title: "Electronic Devices",
//     subtitle: "Evolution of Electronic Devices",
//     description:
//       "Dive Into Emerging Electronic Devices Shaping Smart Technology, Quantum Chips, and IoT Applications. Explore Miniaturization, Circuit Innovation, and Semiconductor Advancements Boosting Performance, Speed, and Connectivity. Revolutionize Consumer Electronics, Medical Equipment, and AI Systems With Power Efficiency, Responsive Design, and Real-Time Data Processing.",
//   },
//   {
//     image: Optics_and_Photonics,
//     title: "Optics and Photonics",
//     subtitle: "Light-Based Tech: Optics & Beyond",
//     description:
//       "Explore Optics and Photonics Driving Fiber Networks, Imaging Solutions, and Quantum Computing. Unlock Light Manipulation Technologies in Communications, Medical Devices, and Industrial Lasers. Enhance Performance With Precision Engineering, High-Speed Data Transmission, and Advanced Light-Matter Interactions for Global Innovation and Technological Mastery.",
//   },
//   {
//     image: Biomedical_Engineering,
//     title: "Biomedical Engineering",
//     subtitle: "Engineering the Future of Health",
//     description:
//       "Discover Biomedical Engineering Advancements Shaping Medical Devices, AI Diagnostics, and Robotic Surgery. Explore Wearables, Imaging Systems, and Regenerative Therapies That Integrate Engineering, Biology, and Innovation. Enhance Patient Care, Data-Driven Health, and Smart Medical Infrastructure With Cutting-Edge Technology and Future-Ready Research Solutions.",
//   },
//   {
//     image: Polymer_Science,
//     title: "Polymer Science",
//     subtitle: "Polymer Science & Smart Materials",
//     description:
//       "Explore Polymer Science Innovations in Sustainable Plastics, Conductive Polymers, and Responsive Materials. Revolutionize Electronics, Packaging, and Biomedicine With Lightweight, Flexible, and High-Performance Compounds. Drive Circular Economy, Environmental Safety, and Technological Progress Using Smart, Engineered, and Application-Specific Polymer Systems.",
//   },
//   {
//     image: ThreeD_Printing_Technology,
//     title: "3D Printing Technology",
//     subtitle: "3D Printing: Design to Reality",
//     description:
//       "Discover 3D Printing Technologies Transforming Manufacturing, Aerospace, and Medicine. Explore Additive Manufacturing, Rapid Prototyping, and Custom Fabrication Powering Efficiency, Precision, and Personalization. Revolutionize Product Development, Reduce Waste, and Accelerate Innovation Using Advanced Materials, Layered Engineering, and Digital Workflow Integration.",
//   },
//   {
//     image: Graphene_Technologies,
//     title: "Graphene Technologies",
//     subtitle: "Graphene: Material of the Future",
//     description:
//       "Explore Graphene Technologies Driving High Conductivity, Mechanical Strength, and Flexibility in Electronics and Energy. Discover One-Atom-Thick Carbon Structures Enabling Quantum Devices, Supercapacitors, and Next-Gen Sensors. Accelerate Breakthroughs in Nanotech, Biomedical Innovation, and Smart Infrastructure With Ultra-Strong and Lightweight Graphene Materials.",
//   },
//   {
//     image: Cognitive_Robotics,
//     title: "Cognitive Robotics",
//     subtitle: "Smarter Machines with Cognition",
//     description:
//       "Unlock Cognitive Robotics Fusing AI, Neuroscience, and Engineering for Human-Like Intelligence. Explore Autonomous Systems, Adaptive Learning, and Real-Time Sensing That Power Service Bots, Smart Vehicles, and Industrial Automation. Enhance Decision-Making, Safety, and Efficiency in Future-Driven Robotic Applications Across Multiple Sectors.",
//   },
//   {
//     image: Cloud_Computing,
//     title: "Cloud Computing",
//     subtitle: "Cloud Computing: Scalable Future",
//     description:
//       "Explore Cloud Computing Solutions Enhancing Data Storage, Scalability, and AI Integration. Discover On-Demand Infrastructure, Secure Access, and Edge Computing That Empower Businesses, Developers, and Enterprises With Flexibility, Global Connectivity, and Real-Time Deployment for High-Efficiency Digital Transformation.",
//   },
//   {
//     image: Machine_Learning,
//     title: "Machine Learning",
//     subtitle: "Machine Learning for Smart Tech",
//     description:
//       "Discover Machine Learning Driving Predictive Analytics, Data Mining, and Automation Across Industries. Explore Supervised and Unsupervised Models Enabling Personalization, Fraud Detection, and Real-Time Decision-Making. Empower Smart Technologies, Business Intelligence, and Scalable AI Solutions That Learn, Adapt, and Optimize Efficiently.",
//   },
//   {
//     image: Neuroscience,
//     title: "Neuroscience",
//     subtitle: "Exploring the Human Brain",
//     description:
//       "Explore Neuroscience Advancements Unraveling Brain Functions, Neural Networks, and Behavioral Science. Discover Applications in Mental Health, AI Simulation, and Cognitive Enhancement. Accelerate Innovations in Neurotech, Brain-Computer Interfaces, and Personalized Therapies Using In-Depth Brain Research and Intelligent Systems.",
//   },
//   {
//     image: AI_in_Cybersecurity,
//     title: "AI in Cybersecurity",
//     subtitle: "AI: Shielding Digital Frontiers",
//     description:
//       "Leverage AI in Cybersecurity to Detect Anomalies, Predict Threats, and Automate Responses. Explore Threat Intelligence, Real-Time Monitoring, and Machine Learning Algorithms That Protect Data Integrity, Infrastructure, and Digital Assets With Precision, Speed, and Resilience in Complex Cyber Landscapes.",
//   },
//   {
//     image: Heterostructures,
//     title: "Heterostructures",
//     subtitle: "Layered Materials, Limitless Possibilities",
//     description:
//       "Explore Heterostructures With Engineered 2D Materials Creating Novel Optical, Mechanical, and Electrical Properties. Enable Quantum Computing, Nanoelectronics, and Smart Sensors Through Atomic Precision, Custom Interfaces, and Advanced Material Integration for Game-Changing Industrial and Scientific Advancements.",
//   },
//   {
//     image: Smart_and_Meta_Materials,
//     title: "Smart and Meta Materials",
//     subtitle: "Responsive & Beyond-Nature Materials",
//     description:
//       "Discover Smart and Meta Materials That Adapt, Sense, and Respond in Real Time. Leverage Programmable Surfaces, Cloaking Effects, and Force Manipulation for Breakthroughs in Defense, Aerospace, and Robotics With Next-Level Structural Intelligence and Physical Control.",
//   },
//   {
//     image: Materials_in_Aerospace,
//     title: "Materials in Aerospace",
//     subtitle: "Advancing Flight Through Materials",
//     description:
//       "Explore Aerospace Materials Built for Extreme Conditions, Weight Reduction, and Thermal Stability. Discover High-Strength Composites, Alloys, and Ceramics Optimizing Safety, Fuel Efficiency, and Structural Integrity Across Aviation, Space Exploration, and Next-Generation Flight Systems.",
//   },
//   {
//     image: Energy_Science,
//     title: "Energy Science",
//     subtitle: "Powering the Future Sustainably",
//     description:
//       "Explore Energy Science Innovations Powering Sustainable Technologies, Renewable Solutions, and Efficient Storage. Discover Hydrogen Cells, Solar Materials, and Smart Grids Enhancing Global Energy Security, Environmental Protection, and Technological Advancements for a Resilient Green Future.",
//   }
// ];

import AI_in_Nanotechnology from '../assets/tracks/AI_in_Nanotechnology.jpg';
import Materials_Science from '../assets/tracks/Materials_Science.jpg';
import Structural_Materials from '../assets/tracks/Structural_Materials.jpg';
import Drug_Delivery_Systems from '../assets/tracks/Drug_Delivery_Systems.jpg';
import Nanomedicine from '../assets/tracks/Nanomedicine.jpg';
import Environmental_Nanotechnology from '../assets/tracks/Environmental_Nanotechnology.jpg';
import Pharmaceutical_Nanotechnology from '../assets/tracks/Pharmaceutical_Nanotechnology.jpg';
import TwoD_Materials from '../assets/tracks/TwoD_Materials.jpg';
import Biopolymers from '../assets/tracks/Biopolymers.jpg';
import Nanofabrications from '../assets/tracks/Nanofabrications.jpg';
import Nanomagnetics from '../assets/tracks/Nanomagnetics.jpg';
import Graphene_Technologies from '../assets/tracks/Graphene_Technologies.jpg';
import Nanoelectronics from '../assets/tracks/Nanoelectronics.jpg';
import Computational_Nanotechnology from '../assets/tracks/Computational_Nanotechnology.jpg';
import Nanodevices_and_Nano_Sensors from '../assets/tracks/Nanodevices_and_Nano_Sensors.jpg';
import Nanophotonics from '../assets/tracks/Nanophotonics.jpg';
import Smart_Materials from '../assets/tracks/Smart_Materials.jpg';
import Nanophysics_and_Nanochemistry from '../assets/tracks/Nanophysics_and_Nanochemistry.jpg';
import Nano_Biotechnology from '../assets/tracks/Nano_Biotechnology.jpg';
import Agri_Nanotechnology from '../assets/tracks/Agri_Nanotechnology.jpg';


export const tracks = [
  {
    image: AI_in_Nanotechnology,
    title: "AI‑Driven Nano Innovation",
    subtitle: "Revolutionizing Nano with AI",
    description:
      "Explore how AI, Machine Learning, and Nanotechnology converge for Precision Design, accelerated simulations, and intelligent Nano‑Diagnostics. Submit work on Predictive Modeling, Autonomous Nanofabrication, or Smart Nanodevices improving efficiency and pioneering next‑generation Nanoengineering solutions for Healthcare, Electronics, and Materials Science.",
  },
  {
    image: Materials_Science,
    title: "Advanced Materials Frontiers",
    subtitle: "Innovations in Materials Science",
    description:
      "Explore Materials Science focusing on Nano‑Structured metals, polymers, ceramics, and composites. Present breakthroughs in Nano‑Enhanced mechanical strength, thermal stability, and multifunctional applications. Ideal for innovation in Aerospace, Electronics, Energy, and Biomedical fields. Submit abstracts shaping next‑generation materials and their global impact.",
  },
  {
    image: Structural_Materials,
    title: "Smart Nano Structures",
    subtitle: "Stronger, Smarter Structures",
    description:
      "Delve into Structural Materials engineered at the Nanoscale for superior Strength, Durability, and Sustainability. Topics include Nano‑Reinforced metals, composite architectures, and advanced ceramics for Infrastructure, Vehicles, and Harsh‑Environmental applications. Present innovations in Nano‑Coatings, lattice structures, and High‑Performance engineering solutions.",
  },
  {
    image: Drug_Delivery_Systems,
    title: "Precision Nano Carriers",
    subtitle: "Biomaterials in Health & Tech",
    description:
      "Showcase advances in Nano‑Enabled Drug Delivery Systems, including Nanoparticles, Liposomes, and smart release mechanisms. Focus on Targeted Delivery, Enhanced Bioavailability, and Minimized Toxicity for pharmaceuticals, therapeutics, and personalized medicine. Submit research on Controlled‑Release platforms and next‑gen Nano‑Carriers optimizing treatment efficacy and patient outcomes.",
  },
  {
    image: Nanomedicine,
    title: "Nanoscale Medical Solutions",
    subtitle: "Biomaterials in Health & Tech",
    description:
      "Explore Nanomedicine innovations driving Diagnostics, Targeted Drug Delivery, and Regenerative Therapies. Showcase Nanoparticles, Nanosensors, and Nano‑Engineered therapeutics that enhance specificity and minimize side effects. Submit research on Cancer Nanotherapy, Immuno‑Nanotechnology, or Personalized Treatment platforms advancing Precision Medicine and next‑generation Healthcare.",
  },
  {
    image: Environmental_Nanotechnology,
    title: "Nanoscale Solutions for Sustainability",
    subtitle: "Powering the Future Sustainably",
    description:
      "Explore how Environmental Nanotechnology delivers smart, eco-friendly solutions for Pollution Remediation, Water Purification, and Air Filtration. Discover the role of Nanomaterials in environmental monitoring and resource conservation. Submit research on Green Nanotechnology, Sustainable Nano Sensors, and Catalytic Materials driving innovation in Climate Resilience and Environmental Protection.",
  },
  {
    image: Pharmaceutical_Nanotechnology,
    title: "Nano Innovation in Pharma",
    subtitle: "Biomaterials in Health & Tech",
    description:
      "Examine how Pharmaceutical Nanotechnology is revolutionizing Drug Formulation, Targeted Delivery, and Bioavailability. Showcase Nano Carriers, Liposomes, Polymeric Nanoparticles, and Nanoemulsions enhancing Therapeutic Efficiency. This track invites contributions focused on Nanomedicine, Vaccine Delivery, and Smart Therapeutics for personalized, responsive, and safer pharmaceutical interventions.",
  },
  {
    image: TwoD_Materials,
    title: "Atomic Layers, Infinite Potential",
    subtitle: "Innovations in Materials Science",
    description:
      "Discover the impact of 2D Materials like Graphene, MXenes, and Transition Metal Dichalcogenides in Electronics, Sensors, Energy Storage, and Flexible Devices. Present breakthroughs in synthesis, properties, and functional integration. This track encourages submissions exploring novel 2D structures driving next-gen innovation in Nanoelectronics and Photonic Devices.",
  },
  {
    image: Biopolymers,
    title: "Green Materials for the Future",
    subtitle: "Polymer Science & Smart Materials",
    description:
      "Explore Biopolymers—renewable, biodegradable materials from nature—shaping Sustainable Packaging, Biomedical Devices, and Agritech. Submit research on Chitosan, Cellulose, PLA, and other Eco-Friendly Polymers engineered at the Nanoscale for structural integrity, drug delivery, and environmental safety. Join the movement toward Circular, Bio-Based Materials Science.",
  },
  {
    image: Nanofabrications,
    title: "Precision Manufacturing at Nanoscale",
    subtitle: "3D Printing: Design to Reality",
    description:
      "Dive into innovations in Nanofabrication techniques like Electron Beam Lithography, Nanoimprint, and Self-Assembly. Showcase your research in patterning, scalability, and integration of Nanoscale Structures for Electronics, Photonics, and Biomedical Devices. This track is ideal for submissions pushing the limits of Nanoscale Engineering and High-Resolution Nano Manufacturing.",
  },
  {
    image: Nanomagnetics,
    title: "Magnetic Phenomena at Nanoscale",
    subtitle: "Stronger, Smarter Structures",
    description:
      "Explore Magnetic Materials and properties at the Nanoscale. Topics include Spintronics, Magnetic Nanoparticles, and Nano-Magnetic Storage. Present innovations in Biomedical Imaging, Targeted Therapy, and Data Systems. Ideal for researchers leveraging Nanomagnetics in Diagnostics, Therapeutics, and Quantum Technology. Submit work on magnetic manipulation, materials design, and Nanoscale Magnetization Dynamics.",
  },
  {
    image: Graphene_Technologies,
    title: "Unleashing Graphene’s Power",
    subtitle: "Graphene: Material of the Future",
    description:
      "Discover how Graphene—a single layer of carbon atoms—is reshaping Nanoelectronics, Biosensors, Batteries, and Flexible Devices. Showcase your work on High-Performance applications leveraging Graphene’s conductivity, flexibility, and strength. This track invites abstracts on Functionalization, Large-Scale Production, and Device Integration in Wearables, Smart Materials, and Energy Storage systems.",
  },
  {
    image: Nanoelectronics,
    title: "Building the Future with Nano",
    subtitle: "Evolution of Electronic Devices",
    description:
      "Focus on Miniaturized Electronic Devices enabled by Nanoelectronics, including Transistors, Memory Devices, Flexible Circuits, and Quantum Dots. Submit research on Fabrication, Integration, and Performance Enhancement at the Nanoscale. This track welcomes innovations in Semiconductors, Sensors, IoT Devices, and Neuromorphic Computing driving next-generation electronic systems.",
  },
  {
    image: Computational_Nanotechnology,
    title: "Simulating the Invisible World",
    subtitle: "AI in Nanotechnology",
    description:
      "Explore how Computational Nanotechnology accelerates discovery through Modeling, AI, and Quantum Simulations. Present your research using tools like Density Functional Theory, Molecular Dynamics, and data-driven design to predict properties and optimize materials. Ideal for those advancing Virtual Experimentation and Predictive Nanoengineering for Materials Science, Electronics, and Medicine.",
  },
  {
    image: Nanodevices_and_Nano_Sensors,
    title: "Detecting the Nanoscale Frontier",
    subtitle: "Evolution of Electronic Devices",
    description:
      "Explore the design and application of Nanodevices and Nano Sensors for Biomedical, Environmental, and Industrial systems. Showcase High-Sensitivity platforms for Disease Detection, Smart Agriculture, and Real-Time Monitoring. Submit innovations in Lab-on-a-Chip, Wearable Sensors, and functional nanostructures enabling Precise, Responsive Sensing across disciplines.",
  },
  {
    image: Nanophotonics,
    title: "Manipulating Light with Nanotech",
    subtitle: "Light-Based Tech: Optics & Beyond",
    description:
      "Focus on the interaction of Light with Nanostructures in Nanophotonics. Showcase breakthroughs in Plasmonics, Metamaterials, Quantum Optics, and Photonic Crystals for imaging, data transfer, and energy. Submit research on Light-Matter interactions driving innovation in Sensors, Optoelectronics, and Next-Generation Communication technologies.",
  },
  {
    image: Smart_Materials,
    title: "Materials That Think and React",
    subtitle: "Smart Materials, Limitless Possibilities",
    description:
      "Discover Smart Materials that respond to stimuli like Heat, Light, or Pressure. Showcase innovations in Shape Memory Alloys, Piezoelectric, and Self-Healing Materials. Submit work demonstrating applications in Biomedical Devices, Robotics, Aerospace, and Wearables, where materials adapt and perform intelligently under dynamic conditions.",
  },
  {
    image: Nanophysics_and_Nanochemistry,
    title: "Atomic-Level Science in Action",
    subtitle: "Revolutionizing Nano with AI",
    description:
      "Explore fundamental principles in Nanophysics and Nanochemistry, where Quantum Effects, Surface Chemistry, and Electron Behavior define novel materials. This track encourages submissions on Catalysis, Energy Materials, and Structure-Property relationships driving Nanoscience. Ideal for those bridging Physics, Chemistry, and Engineering at the atomic level.",
  },
  {
    image: Nano_Biotechnology,
    title: "Where Nano Meets Biology",
    subtitle: "Engineering the Future of Health",
    description:
      "Focus on Nano Biotechnology innovations integrating Nanotechnology with Genetics, Cell Biology, and Therapeutics. Submit work on Gene Delivery, Biosensors, and Nano-Enabled Diagnostics. This track encourages interdisciplinary research revolutionizing Healthcare, Agriculture, and Diagnostics with precise, scalable, and biocompatible Nano‑Tools.",
  },
  {
    image: Agri_Nanotechnology,
    title: "Smart Farming with Nanotech",
    subtitle: "Engineering the Future of Health",
    description:
      "Explore how Agri Nanotechnology transforms farming with Nano Fertilizers, Smart Pesticides, and Soil Monitoring Sensors. Submit research on Sustainable Agriculture powered by Nanomaterials that increase Yield, reduce Waste, and improve Resource Use. Ideal for contributors merging Nanoscience with Food Security, Crop Protection, and Environmental Sustainability.",
  },
];



const StaticTracks = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <style>{`
        @keyframes pulseShadow {
          0%, 100% {
            box-shadow: 0 0 0px #009bae;
          }
          50% {
            box-shadow: 0 0 18px 6px #009bae;
          }
        }

        .animate-pulseShadow {
          animation: pulseShadow 3s ease-in-out infinite;
        }

        .transition-custom {
          transition: all 0.8s ease-in-out;
        }
      `}</style>

      <div className="relative mt-14">
        {/* Fixed Top-Right Button */}
        <div
          className="fixed top-[22%] right-[1%] z-50 transition-custom"
        >
          <a
            href="/abstract-submission"
            aria-label="Submit abstract"
            className="bg-one rounded-full text-white text-sm font-medium px-3 py-3 select-none transition-transform hover:scale-110 animate-pulseShadow"
          >
            Submit Abstract
          </a>
        </div>

        {/* Track Content */}
        <div className="container mx-auto px-4 py-10 space-y-20 flex flex-col items-center">
          {tracks.map((track, index) => (
            <div
              key={index}
              className="relative w-[80%] flex flex-col md:flex-row items-stretch md:space-x-6"
            >
              <div className="flex-shrink-0 bg-white border shadow-xl rounded-2xl p-2 w-full md:w-1/3">
                <img
                  src={track.image}
                  alt={track.title}
                  className="w-full h-full object-cover rounded-xl"
                  loading="lazy"
                />
              </div>
              <div className="bg-white border shadow-xl rounded-2xl p-6 w-full md:w-2/3 mt-12 md:mt-0 flex flex-col justify-center">
                <h2 className="text-3xl font-bold mb-1 text-one flex items-center gap-2">
                  <Sparkle className="fill-one" />
                  {track.title}
                </h2>
                <h3 className="text-xl text-gray-600 font-semibold mb-3">
                  {track.subtitle}
                </h3>
                <p className="text-md text-gray-800 leading-relaxed">
                  {track.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default StaticTracks;